import * as ActionTypes from '../ActionTypes';

export const GetPayrollTemplateAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_TEMPLATE_GET_REQUEST,
        params
    }
}

export const AddPayrollTemplateAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_TEMPLATE_ADD_REQUEST,
        params
    }
}

export const UpdatePayrollTemplatetAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_TEMPLATE_UPDATE_REQUEST,
        params
    }
}

export const DeletePayrollTemplateAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_TEMPLATE_DELETE_REQUEST,
        params
    }
}

export const GetPayrollSettingsAction = (params) => {
    return {
        type: ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_REQUEST,
        params
    }
}

export const AddLWFAction = (params) => {
    return {
        type: ActionTypes.LWF_ADD_REQUEST,
        params
    }
}

export const UpdateLWFAction = (params) => {
    return {
        type: ActionTypes.LWF_UPDATE_REQUEST,
        params
    }
}

export const DeleteLWFAction = (params) => {
    return {
        type: ActionTypes.LWF_DELETE_REQUEST,
        params
    }
}

export const GetOTAction = (params) => {
    return {
        type: ActionTypes.OT_GET_REQUEST,
        params
    }
}

export const AddOTAction = (params) => {
    return {
        type: ActionTypes.OT_ADD_REQUEST,
        params
    }
}

export const UpdateOTAction = (params) => {
    return {
        type: ActionTypes.OT_UPDATE_REQUEST,
        params
    }
}

export const DeleteOTAction = (params) => {
    return {
        type: ActionTypes.OT_DELETE_REQUEST,
        params
    }
}

// Leave Wage Actions
export const GetLeaveWageAction = (params) => {
    return {
        type: ActionTypes.LEAVE_WAGE_GET_REQUEST,
        params
    }
}

export const AddLeaveWageAction = (params) => {
    return {
        type: ActionTypes.LEAVE_WAGE_ADD_REQUEST,
        params
    }
}

export const UpdateLeaveWageAction = (params) => {
    return {
        type: ActionTypes.LEAVE_WAGE_UPDATE_REQUEST,
        params
    }
}

export const DeleteLeaveWageAction = (params) => {
    return {
        type: ActionTypes.LEAVE_WAGE_DELETE_REQUEST,
        params
    }
}
// FOOD Allowance Actions
export const GetFoodAllowanceAction = (params) => {
    return {
        type: ActionTypes.FOOD_ALLOWANCE_GET_REQUEST,
        params
    }
}
export const UpdateFoodAllowanceAction = (params) => {
    return {
        type: ActionTypes.FOOD_ALLOWANCE_UPDATE_REQUEST,
        params
    }
}
// Transport Allowance Actions
export const GetTransportAllowanceAction = (params) => {
    return {
        type: ActionTypes.TRANSPORT_ALLOWANCE_GET_REQUEST,
        params
    }
}

export const AddTransportAllowanceAction = (params) => {
    return {
        type: ActionTypes.TRANSPORT_ALLOWANCE_ADD_REQUEST,
        params
    }
}

export const UpdateTransportAllowanceAction = (params) => {
    return {
        type: ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_REQUEST,
        params
    }
}

export const DeleteTransportAllowanceAction = (params) => {
    return {
        type: ActionTypes.TRANSPORT_ALLOWANCE_DELETE_REQUEST,
        params
    }
}

// PH Allowance Actions
export const GetPHAllowanceAction = (params) => {
    return {
        type: ActionTypes.PH_ALLOWANCE_GET_REQUEST,
        params
    }
}

export const AddPHAllowanceAction = (params) => {
    return {
        type: ActionTypes.PH_ALLOWANCE_ADD_REQUEST,
        params
    }
}

export const UpdatePHAllowanceAction = (params) => {
    return {
        type: ActionTypes.PH_ALLOWANCE_UPDATE_REQUEST,
        params
    }
}

export const DeletePHAllowanceAction = (params) => {
    return {
        type: ActionTypes.PH_ALLOWANCE_DELETE_REQUEST,
        params
    }
}

// Statutory Bonus Actions
export const GetBonusConfigurationAction = (params) => {
    return {
        type: ActionTypes.BONUS_CONFIGURATION_GET_REQUEST,
        params
    }
}

export const UpdateBonusConfigurationAction = (params) => {
    return {
        type: ActionTypes.BONUS_CONFIGURATION_UPDATE_REQUEST,
        params
    }
}

// Adjustment Components Actions
export const GetAdjustmentComponentsAction = (params) => {
    return {
        type: ActionTypes.ADJUSTMENT_COMPONENTS_GET_REQUEST,
        params
    }
}

export const AddAdjustmentComponentsAction = (params) => {
    return {
        type: ActionTypes.ADJUSTMENT_COMPONENTS_ADD_REQUEST,
        params
    }
}

export const UpdateAdjustmentComponentsAction = (params) => {
    return {
        type: ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_REQUEST,
        params
    }
}

export const DeleteAdjustmentComponentsAction = (params) => {
    return {
        type: ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_REQUEST,
        params
    }
}